const state = {
	action: null,
	level: null,
	bedrooms: null,
	view: null,
	terraces: false,
	lockouts: false
};

const showDownloadPlanLink = (level) => {
	const links = document.querySelectorAll('.floor-plate__download-link');
	links.forEach((floorPlateLevel) => {
		floorPlateLevel.classList.remove('floor-plate__download-link--active');
	});
	
	document.querySelector(`#pdf-level-${level}`).classList.add('floor-plate__download-link--active');
}

const showLevel = (level) => {
	const floorPlateLevels = document.querySelectorAll('.floor-plate__level');
	floorPlateLevels.forEach((floorPlateLevel) => {
		floorPlateLevel.classList.remove('floor-plate__level--active');
	});
	
	document.querySelector(`#level-${level}`).classList.add('floor-plate__level--active');
};

const filterRooms = () => {
	console.log(state);
	
	if (state.action === 'level') {
		showLevel(state.level);
		showDownloadPlanLink(state.level);
	} else {
		let filterClass = '.floor-plate__room';
		
		if (state.bedrooms) {
			filterClass += `.bedrooms-${state.bedrooms}`;
		}
		
		if (state.view) {
			filterClass += `.view-${state.view}`;
		}
		
		if (state.terraces) {
			filterClass += '.terraces';
		}
		
		if (state.lockouts) {
			filterClass += '.lockouts';
		}
		
		const allRooms = document.querySelectorAll('.floor-plate__room');
		allRooms.forEach((room) => {
			room.classList.remove('active');
		});
		
		const rooms = document.querySelectorAll(filterClass);
		
		rooms.forEach((room) => {
			room.classList.add('active');
		});
	}
};

const initFilter = () => {
	const filterOptionLists = document.querySelectorAll('.filter-options');
	const filterCheckboxes = document.querySelectorAll('.filters__checkbox-input');
	
	if (filterOptionLists.length > 0) {
		filterOptionLists.forEach((filterOptionList) => {
			filterOptionList.addEventListener('click', (evt) => {
				if (evt.target.dataset.value && !evt.target.classList.contains('dropdown__item--active')) {
					
					const filterToggle = filterOptionList.previousElementSibling;
					
					filterOptionList.classList.remove('dropdown__list--active');
					filterToggle.classList.remove('dropdown__toggle--active');
					
					filterToggle.textContent = evt.target.textContent;
					filterOptionList.querySelector('.dropdown__item--active').classList.remove('dropdown__item--active');
					evt.target.classList.add('dropdown__item--active');
					
					state.action = filterOptionList.dataset.action;
					state[filterOptionList.dataset.action] = evt.target.dataset.value === 'all' ? null : evt.target.dataset.value;
					filterRooms();
				}
			});
		});
	}
	
	if (filterCheckboxes.length > 0) {
		filterCheckboxes.forEach((filterCheckbox) => {
			filterCheckbox.addEventListener('change', () => {
				state.action = filterCheckbox.name;
				state[filterCheckbox.name] = filterCheckbox.checked;
				filterRooms();
			})
		});
	}
};

export default initFilter;
